import {Component, ElementRef, ViewChild} from '@angular/core';
import { NotesService } from '../../../shared/services/notes.service';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';

@Component({
    selector: 'notes-component',
    templateUrl: './notes.component.html',
    styleUrls: [ './notes.component.scss' ]
})
export class NotesComponent {

    // Two copies of the text are stored in the component. The textAreaText corresponds to an ngModel that
    // stays in sync during an editing session. The readOnlyText is needed if the edit operation is canceled
    // and the text needs to be reset to its original value.
    readOnlyText: string;
    textAreaText: string;
    uuid: string;
    editable = false;
    finalHeight = "40";

    constructor(private notesService: NotesService,
                private submissionHistoryService: SubmissionHistoryService) {
    }


    // Called whenever a note icon is clicked - either opening the sidebar
    // or switching from one UUID to another
    public reset(uuid: string, text: string) {
        this.editable = false;
        this.uuid = uuid;
        this.readOnlyText = text;
        this.textAreaText = text;
    }


    // Called when the "Add Note" button is clicked.
    // If there's existing note text, add a line at the top of the textarea and position
    // the cursor at the very beginning to set the user up for entering a new note.
    // Focus must also be explicitly transferred to the textarea.
    addNote() {
        if (this.textAreaText != null && this.textAreaText.trim() !== '' ) {
            this.textAreaText = '\n' + this.textAreaText;
        }
        this.editable = true;

        setTimeout(function() {
            let elem = <HTMLInputElement>document.getElementById('note-text-edit');
            elem.focus();
            elem.setSelectionRange(0, 0);
            elem.scrollTop = 0;
        }, 0);
    }


    // Called when "Save" button is clicked
    save() {
        this.textAreaText = this.readOnlyText = this.textAreaText.trim();
        this.editable = false;
        this.submissionHistoryService.saveNotes(this.uuid, this.readOnlyText)
            .then(response => {
                // if(!response.ok) {
                //     alert("Error saving note.\n\n" + response);
                // }
            });

        // This tells the submission history component to toggle the purple icon on/off if necessary
        if (this.readOnlyText.trim() === '') {
            this.notesService.setNoteExists(this.uuid, false);
        } else {
            this.notesService.setNoteExists(this.uuid, true);
        }
    }


    // Called when "Cancel" button is clicked
    cancel() {
        this.textAreaText = this.readOnlyText;
        this.editable = false;
    }
}
